import React, { useEffect } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { AdminListingDto, AdminListingRequestDto } from 'services/data-contracts';
import { Button, useModelStateContext } from 'saladsoft-primitive';
import { useStateContext } from 'providers/usePageState';
import LocalizeEditor from 'components/input/LocalizeEditor';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import { saveListing } from 'controllers/listingsController';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InnerSection } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';

const DescriptionPage = () => {
  const { listing, setListing } = useStateContext();
  const { serviceModel, updateServiceModel, updateServiceModelMultiple } =
    useModelStateContext<AdminListingRequestDto>();

  const handleSave = async () => {
    if (serviceModel.current) {
      const newListing = (await saveListing(serviceModel.current)) as AdminListingDto;
      setListing(newListing);
    }
  };

  useEffect(() => {
    if (listing) {
      updateServiceModelMultiple(listing);
    }
  }, [listing]);

  return (
    <PageLayout title="설명">
      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3" style={{ marginBottom: 10 }}>
              시설 설명
            </Text>
            <Text type="H4" buttonRole="DESCRIPTION">
              상세 설명은 HTML형식으로 입력 및 편집이 가능합니다.
              <br />
            </Text>
          </div>
          {listing && (
            <LocalizeEditor
              defaultValue={listing?.localizedDesc}
              onChange={(value) => {
                updateServiceModel('localizedDesc', value);
              }}
            />
          )}
        </InnerGroup>
      </InnerSection>

      <ButtonWrapper>
        <Button style={{ width: 100 }} onClick={handleSave}>
          저장
        </Button>
      </ButtonWrapper>
    </PageLayout>
  );
};

export default DescriptionPage;
